export const parseFromSessionStorage = (key) =>
  JSON.parse(sessionStorage.getItem(key) || "{}");
